import { FormControl, MenuItem, InputLabel, Select, Autocomplete, TextField } from "@mui/material";


function SelectUser(props)
{
    const handleChange = (event, newValue) => {
        props.setUserId(newValue ? newValue.cerptsUserId : '0');
    }

    // Find the selected user object for display
    const selectedUser = props.allUsers && props.allUsers.length > 0 
        ? props.allUsers.find(user => user.cerptsUserId === props.userId)
        : null;

    return(
    <>
    <FormControl className="formControl">
        <Autocomplete
            options={props.allUsers || []}
            getOptionLabel={(option) => option.email || ''}
            value={selectedUser}
            onChange={handleChange}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Current Users"
                    placeholder="Search users..."
                />
            )}
            isOptionEqualToValue={(option, value) => option.cerptsUserId === value.cerptsUserId}
            noOptionsText="No users found"
            clearOnBlur={false}
        />
    </FormControl>         
    </>
    );
}

export default SelectUser;